import { ACCESS_TOKEN } from '../assets/constants'
import { ensureValidAccessToken } from '../services/auth/tokenRefresh'

type Phase = 'auth' | 'profile' | 'chart' | 'open'

const PHASE_RANK: Record<Phase, number> = {
	auth: 0,
	profile: 1,
	chart: 2,
	open: 3
}

let phase: Phase = 'auth'
const listeners = new Set<() => void>()
let openTimer: ReturnType<typeof setTimeout> | null = null

function notify() {
	listeners.forEach((listener) => listener())
}

function setPhase(next: Phase) {
	if (PHASE_RANK[next] <= PHASE_RANK[phase]) return
	phase = next
	notify()
}

function isAuthRoute() {
	const path = window.location.pathname
	return path.includes('/login') || path.includes('/auth-status') || path.includes('/signup')
}

function isChartRequest(url: string) {
	if (url.includes('/v2/security/all')) return false
	return (
		url.includes('/user-dashboards') ||
		url.includes('/supercharts/') ||
		url.includes('/v2/security') ||
		url.includes('/candles/bulk') ||
		url.includes('/user-security-expression')
	)
}

function requiredPhase(url: string): Phase {
	if (url.includes('/v2/security/all')) return 'profile'
	if (url.includes('/user/me')) return 'profile'
	if (isChartRequest(url)) return 'chart'
	return 'open'
}

function canProceed(url: string) {
	if (!localStorage.getItem(ACCESS_TOKEN) || isAuthRoute()) return true
	return PHASE_RANK[phase] >= PHASE_RANK[requiredPhase(url)]
}

export function waitForInitialLoadSlot(url: string): Promise<void> {
	if (canProceed(url)) return Promise.resolve()
	return new Promise((resolve) => {
		const check = () => {
			if (!canProceed(url)) return
			listeners.delete(check)
			resolve()
		}
		listeners.add(check)
	})
}

export function markProfileLoaded() {
	setPhase('chart')
	if (openTimer) clearTimeout(openTimer)
	openTimer = setTimeout(() => setPhase('open'), 8000)
}

export function markChartDataRequested() {
	setPhase('open')
}

void ensureValidAccessToken().finally(() => {
	setPhase('profile')
	if (!openTimer) {
		openTimer = setTimeout(() => setPhase('open'), 8000)
	}
})
